// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './SearchResultItem.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const SearchResultItem = ({ name, description, onSelect, id, isLast, disabled }) => (
  <div
    role='presentation'
    className={`search-result-item-container ${disabled ? 'search-result-item-disabled' : ''}`}
    style={{}}
    onClick={(e) => {
      if (!disabled) onSelect({ name, description, id })
      e.stopPropagation()
    }}>
    <div className={`search-result-text-container ${disabled ? 'search-result-item-disabled' : ''}`}>
      <label htmlFor='null' className={`search-result-text bold ${disabled ? 'search-result-item-disabled' : ''}`}>
        {name}
      </label>
      <label htmlFor='null' className={`search-result-text ${disabled ? 'search-result-item-disabled' : ''}`}>
        {description}
      </label>
    </div>
    {!isLast && <div className='search-result-separate-line' />}
  </div>
)
